import { createClient, fetchExchange, cacheExchange } from 'urql';
import { createMockFetch } from './mocks/index.js';
import { createIdempotencyKey } from '@/utils/idempotency.js';
import { resolveAuthenticatedHeaders } from '@/utils/requestContext.js';

const API_URL =
  import.meta.env.VITE_GRAPHQL_URL ||
  `${import.meta.env.VITE_API_URL || 'https://api.sinamonsoft.ar'}/graphql`;
const USE_MOCKS = import.meta.env?.VITE_USE_MOCKS === '1';

let clientInstance;

function buildHeaders() {
  return resolveAuthenticatedHeaders();
}

function isMutationRequest(body) {
  if (!body || typeof body !== 'string') return false;
  try {
    const payload = JSON.parse(body);
    return typeof payload?.query === 'string' && /^\s*mutation\b/i.test(payload.query);
  } catch {
    return false;
  }
}

function createWrappedFetch(baseFetch) {
  return async (input, init = {}) => {
    const { receiptOperationGuard, ...fetchInit } = init;
    const headers = new Headers();

    Object.entries(buildHeaders()).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        headers.set(key, value);
      }
    });

    new Headers(init.headers || {}).forEach((value, key) => {
      headers.set(key, value);
    });

    if (isMutationRequest(init.body)) {
      headers.set('x-idempotency-key', createIdempotencyKey('mutation'));
    }

    // Only durable receipt mutations supply this guard; other operations are unchanged.
    receiptOperationGuard?.(headers);
    return baseFetch(input, {
      ...fetchInit,
      headers,
    });
  };
}

export function getGqlClient() {
  if (!clientInstance) {
    const baseFetch = USE_MOCKS ? createMockFetch() : fetch.bind(globalThis);
    clientInstance = createClient({
      url: API_URL,
      exchanges: [cacheExchange, fetchExchange],
      fetch: createWrappedFetch(baseFetch),
    });
  }
  return clientInstance;
}

export const gqlClient = getGqlClient();

export function isMockGraphqlEnabled() {
  return USE_MOCKS;
}
